import { Brand } from "./Brand";

export function AuthLayout({ children, title, subtitle, image }) {
  return (
    <div className="min-h-screen w-full bg-[#FAF9F6] lg:grid lg:grid-cols-2">
      {/* Left / form */}
      <div className="flex min-h-screen flex-col px-6 py-8 sm:px-12 lg:px-16">
        <Brand />
        <div className="flex flex-1 flex-col justify-center py-10">
          <div className="mx-auto w-full max-w-md">
            <p className="text-xs uppercase tracking-[0.14em] text-[#515E58]">
              Mental &amp; Behavioral Health Contractor
            </p>
            <h1 className="mt-2 font-heading text-3xl font-bold tracking-tight text-[#1F2924] sm:text-4xl">
              {title}
            </h1>
            {subtitle && <p className="mt-3 text-[#515E58]">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
        </div>
        <p className="text-xs text-[#515E58]">© {new Date().getFullYear()} GIC&amp;E Inc. All rights reserved.</p>
      </div>

      {/* Right / image */}
      <div className="relative hidden lg:block">
        <img src={image} alt="GIC&E" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#2C5545]/55" />
        <div className="absolute inset-0 flex flex-col justify-end p-14 text-white">
          <blockquote className="max-w-lg font-heading text-2xl font-medium leading-snug">
            "Our work requires more than a passion for helping people — it requires judgment,
            competency, and heart."
          </blockquote>
          <p className="mt-4 text-sm text-white/80">GIC&amp;E Contractor Pre-Screening &amp; Competency Program</p>
        </div>
      </div>
    </div>
  );
}
